export default "__VITE_ASSET__BMR1fqSD__"